import React, { useState } from 'react';
import './Index.css';
import Facebook from '../../Assets/Photos/facebook-logo.png';
import Google from '../../Assets/Photos/google-logo.png';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import HttpsIcon from '@material-ui/icons/Https';
import { StaticContainer } from '..';
import { Link } from 'react-router-dom';
import { SigninInput } from '../../Components';
import { useUser } from '../../Context/User';
import { asyncLocalStorage } from '../../Helpers/LocalStorage';
import Logo from '../../Assets/Photos/cogmindlogo.png'

const Signup = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(false);
    const [password, setPassword] = useState('');
    const { login } = useUser();
    const loginHanlder = async (e) => {
        e.preventDefault();
        setError(false);
        if (email === 'admin@cogminds.co' && password === 'admin@123') {
            await asyncLocalStorage.setItem(
                'token',
                JSON.stringify({
                    token: 'ANS5WUN2NKK',
                    role: 'admin',
                    name: 'Kushagra',
                })
            );
            login('ANS5WUN2NKK', 'Kushagra', 'admin', 100);
        } else if (email === 'merchant@cogminds.co' && password === 'merchant@123') {
            await asyncLocalStorage.setItem(
                'token',
                JSON.stringify({
                    token: 'ANS5WUN2NKK',
                    role: 'merchant',
                    name: 'John Doe',
                })
            );
            login('ANS5WUN2NKK', 'John Doe', 'merchant', 100);
        } else {
            setError(true);
        }
    };
    return (
        <StaticContainer>
            <div className="main-static">
                <img src={Logo} height={71} width={170} style={{ marginBottom: '20px' }} />
                <h2 className="main-static-subheading">Hi, Welcome Back</h2>
                <button className="btn-white">
                    <img className="btn-img" src={Google} alt="Google" />
                    <p>Sign in with Google</p>
                </button>
                <button style={{ marginTop: '10px' }} className="btn-white">
                    <img className="btn-img" src={Facebook} alt="Facebook" />
                    <p>Sign in with Facebook</p>
                </button>
                <p className="side_line_text">Or Sign in Email</p>
                {error && <p className="login_error">Login Failed! Please Check Credentials!</p>}
                <form onSubmit={loginHanlder} className="main-static-form" action="submit">
                    <SigninInput
                        label="Enter Email Address"
                        name="email"
                        Icon={MailOutlineIcon}
                        type="email"
                        value={email}
                        changeHandler={(e) => {
                            setEmail(e.target.value);
                        }}
                    />
                    <SigninInput
                        label="Enter Password"
                        name="password"
                        Icon={HttpsIcon}
                        type="password"
                        value={password}
                        changeHandler={(e) => {
                            setPassword(e.target.value);
                        }}
                    />
                    <button className="btn-orange" style={{ fontWeight: '600' }} type="submit">
                        Login
                    </button>
                </form>
                <p className="main-static-text">
                    <Link to="/forgotPassword">Forogt Password?</Link>
                </p>
                <p className="main-static-text">
                    Not Registered Yet? <Link to="/signup">Create an Account</Link>
                </p>
                <p className="main-static-footer-text">
                    © 2021 powered by Cogminds. Designed and developed by threearrow technologies.{' '}
                </p>
            </div>
        </StaticContainer>
    );
};

export default Signup;
